import { Gender } from '../../domain/models/gender.enum';
import { Action } from '../action.type';

export const RETRIEVE_FIGHTER_IMAGE = 'RETRIEVE_FIGHTER_IMAGE';
export const RETRIEVE_FIGHTER_IMAGE_SUCCESS = 'RETRIEVE_FIGHTER_IMAGE_SUCCESS';
export const RETRIEVE_FIGHTER_IMAGE_FAILURE = 'RETRIEVE_FIGHTER_IMAGE_FAILURE';

export type RetrieveFighterImagePayload = {
  firstName?: string;
  lastName?: string;
  dob: Date;
  gender: Gender;
  retry: number;
};

export type RetrieveFighterImageSuccessPayload = {
  imagePath: string;
  image: string;
};

export interface RetrieveFighterImage
  extends Action<RetrieveFighterImagePayload> {
  type: typeof RETRIEVE_FIGHTER_IMAGE;
  payload: RetrieveFighterImagePayload;
}

export interface RetrieveFighterImageSuccess
  extends Action<RetrieveFighterImageSuccessPayload> {
  type: typeof RETRIEVE_FIGHTER_IMAGE_SUCCESS;
  payload: RetrieveFighterImageSuccessPayload;
}

export interface RetrieveFighterImageFailure extends Action<string> {
  type: typeof RETRIEVE_FIGHTER_IMAGE_FAILURE;
  payload: string;
}
